import axios from 'axios';
import { DEFAULT_USER_DATA } from '../constants';

export async function getConfiguration() {
  const timestamp = new Date().getTime();

  const {
    data: { urls, keys, env },
  } = await axios.get(`/config/config.json?q=${timestamp}`);
  const { data: version } = await axios.get(
    `/config/version.json?q=${timestamp}`,
  );
  const { data: secretKeys } = await axios.get(
    `/config/keys.json?q=${timestamp}`,
  );
  const { data: secretTokens } = await axios.get(
    `/config/tokens.json?q=${timestamp}`,
  );

  return {
    env,
    urls,
    keys: {
      ...keys,
      ...secretKeys,
      ...secretTokens,
    },
    version: {
      version: version.version,
      versionFull: `${version.version} build ${version.build} (${
        version.timestamp
      })`,
    },
  };
}

export async function getUserData(firebase) {
  const getCurrentUser = auth => {
    return new Promise((resolve, reject) => {
      const unsubscribe = auth.onAuthStateChanged(user => {
        unsubscribe();
        resolve(user);
      }, reject);
    });
  };

  const user = await getCurrentUser(firebase.auth());
  if (!user) {
    return DEFAULT_USER_DATA;
  }

  const userData = await firebase.auth().currentUser.getIdTokenResult();
  return userData;
}
